import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class DiskProfileFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  codeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get code():any {
    return this.codeChange.value;
  }
  set code(value:any) {
    this.codeChange.next(value);
    this.emitChange("code", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(value:any) {
    this.descriptionChange.next(value);
    this.emitChange("description", value);
  }

  activeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get active():any {
    return this.activeChange.value;
  }
  set active(value:any) {
    this.activeChange.next(value);
    this.emitChange("active", value);
  }

  templateChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get template():any {
    return this.templateChange.value;
  }
  set template(value:any) {
    this.templateChange.next(value);
    this.emitChange("templateName", value);
  }

  platformChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get platform():any {
    return this.platformChange.value;
  }
  set platform(value:any) {
    this.platformChange.next(value);
    this.emitChange("platformName", value);
  }

  osVersionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osVersion():any {
    return this.osVersionChange.value;
  }
  set osVersion(value:any) {
    this.osVersionChange.next(value);
    this.emitChange("osVersionName", value);
  }

  osDefaultDiskSizeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osDefaultDiskSize():any {
    return this.osDefaultDiskSizeChange.value;
  }
  set osDefaultDiskSize(value:any) {
    this.osDefaultDiskSizeChange.next(value);
    this.emitChange("osDefaultDiskSize", value);
  }

  minGBChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get minGB():any {
    return this.minGBChange.value;
  }
  set minGB(value:any) {
    this.minGBChange.next(value);
    this.emitChange("minGB", value);
  }

  maxGBChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get maxGB():any {
    return this.maxGBChange.value;
  }
  set maxGB(value:any) {
    this.maxGBChange.next(value);
    this.emitChange("maxGB", value);
  }

  osDiskTypeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osDiskType():any {
    return this.osDiskTypeChange.value;
  }
  set osDiskType(value:any) {
    this.osDiskTypeChange.next(value);
    this.emitChange("osDiskType", value);
  }

  osMountChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osMount():any {
    return this.osMountChange.value;
  }
  set osMount(value:any) {
    this.osMountChange.next(value);
    this.emitChange("osMount", value);
  }

  reasonChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get reason():any {
    return this.reasonChange.value;
  }
  set reason(value:any) {
    this.reasonChange.next(value);
    this.emitChange("reason", value);
  }

  maxAdditionalDisksChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get maxAdditionalDisks():any {
    return this.maxAdditionalDisksChange.value;
  }
  set maxAdditionalDisks(value:any) {
    this.maxAdditionalDisksChange.next(value);
    this.emitChange("maxAdditionalDisks", value);
  }

  maxTotalDisksChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get maxTotalDisks():any {
    return this.maxTotalDisksChange.value;
  }
  set maxTotalDisks(value:any) {
    this.maxTotalDisksChange.next(value);
    this.emitChange("maxTotalDisks", value);
  }

  storageTierChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get storageTier():any {
    return this.storageTierChange.value;
  }
  set storageTier(value:any) {
    this.storageTierChange.next(value);
    this.emitChange("storageTierName", value);
  }

  encryptionMandatoryChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get encryptionMandatory():any {
    return this.encryptionMandatoryChange.value;
  }
  set encryptionMandatory(value:any) {
    this.encryptionMandatoryChange.next(value);
    this.emitChange("encryptionMandatory", value);
  }

  engineerAddChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get engineerAdd():any {
    return this.engineerAddChange.value;
  }
  set engineerAdd(value:any) {
    this.engineerAddChange.next(value);
    this.emitChange("engineerAdd", value);
  }

  engineerResizeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get engineerResize():any {
    return this.engineerResizeChange.value;
  }
  set engineerResize(value:any) {
    this.engineerResizeChange.next(value);
    this.emitChange("engineerResize", value);
  }

  notesChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get notes():any {
    return this.notesChange.value;
  }
  set notes(value:any) {
    this.notesChange.next(value);
    this.emitChange("notes", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.code && this.code !== '') {
      params = params.set("code", this.code);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }
    if (this.active && this.active !== '') {
      params = params.set("active", this.active);
    }
    if (this.template && this.template !== '') {
      params = params.set("templateName", this.template);
    }
    if (this.platform && this.platform !== '') {
      params = params.set("platformName", this.platform);
    }
    if (this.osVersion && this.osVersion !== '') {
      params = params.set("osVersionName", this.osVersion);
    }
    if (this.osDefaultDiskSize && this.osDefaultDiskSize !== '') {
      params = params.set("osDefaultDiskSize", this.osDefaultDiskSize);
    }
    if (this.minGB && this.minGB !== '') {
      params = params.set("minGB", this.minGB);
    }
    if (this.maxGB && this.maxGB !== '') {
      params = params.set("maxGB", this.maxGB);
    }
    if (this.osDiskType && this.osDiskType !== '') {
      params = params.set("osDiskType", this.osDiskType);
    }
    if (this.osMount && this.osMount !== '') {
      params = params.set("osMount", this.osMount);
    }
    if (this.reason && this.reason !== '') {
      params = params.set("reason", this.reason);
    }
    if (this.maxAdditionalDisks && this.maxAdditionalDisks !== '') {
      params = params.set("maxAdditionalDisks", this.maxAdditionalDisks);
    }
    if (this.maxTotalDisks && this.maxTotalDisks !== '') {
      params = params.set("maxTotalDisks", this.maxTotalDisks);
    }
    if (this.storageTier && this.storageTier !== '') {
      params = params.set("storageTierName", this.storageTier);
    }
    if (this.encryptionMandatory && this.encryptionMandatory !== '') {
      params = params.set("encryptionMandatory", this.encryptionMandatory);
    }
    if (this.engineerAdd && this.engineerAdd !== '') {
      params = params.set("engineerAdd", this.engineerAdd);
    }
    if (this.engineerResize && this.engineerResize !== '') {
      params = params.set("engineerResize", this.engineerResize);
    }
    if (this.notes && this.notes !== '') {
      params = params.set("notes", this.notes);
    }

    return params;
  }

  setFilters(props: any): void {
    this.codeChange.next(props.code || undefined);
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.descriptionChange.next(props.description || undefined);
    this.activeChange.next(props.active || undefined);
    this.templateChange.next(props.template || undefined);
    this.platformChange.next(props.platform || undefined);
    this.osVersionChange.next(props.osVersion || undefined);
    this.osDefaultDiskSizeChange.next(props.osDefaultDiskSize || undefined);
    this.minGBChange.next(props.minGB || undefined);
    this.maxGBChange.next(props.maxGB || undefined);
    this.osDiskTypeChange.next(props.osDiskType || undefined);
    this.osMountChange.next(props.osMount || undefined);
    this.reasonChange.next(props.reason || undefined);
    this.maxAdditionalDisksChange.next(props.maxAdditionalDisks || undefined);
    this.maxTotalDisksChange.next(props.maxTotalDisks || undefined);
    this.storageTierChange.next(props.storageTier || undefined);
    this.encryptionMandatoryChange.next(props.encryptionMandatory || undefined);
    this.engineerAddChange.next(props.engineerAdd || undefined);
    this.engineerResizeChange.next(props.engineerResize || undefined);
    this.notesChange.next(props.notes || undefined);
  }

  toObj() {
    let obj:any = {};
    obj.code = this.code;
    obj.companyId = this.companyId;
    obj.name = this.name;
    obj.description = this.description;
    obj.active = this.active;
    obj.template = this.template;
    obj.platform = this.platform;
    obj.osVersion = this.osVersion;
    obj.osDefaultDiskSize = this.osDefaultDiskSize;
    obj.minGB = this.minGB;
    obj.maxGB = this.maxGB;
    obj.osDiskType = this.osDiskType;
    obj.osMount = this.osMount;
    obj.reason = this.reason;
    obj.maxAdditionalDisks = this.maxAdditionalDisks;
    obj.maxTotalDisks = this.maxTotalDisks;
    obj.storageTier = this.storageTier;
    obj.encryptionMandatory = this.encryptionMandatory;
    obj.engineerAdd = this.engineerAdd;
    obj.engineerResize = this.engineerResize;
    obj.notes = this.notes;

    return obj;
  }

  public clear():void {
    this.code = undefined;
    this.companyId = this.auth.getCompanyId();
    this.name = undefined;
    this.description = undefined;
    this.active = undefined;
    this.template = undefined;
    this.platform = undefined;
    this.osVersion = undefined;
    this.osDefaultDiskSize = undefined;
    this.minGB = undefined;
    this.maxGB = undefined;
    this.osDiskType = undefined;
    this.osMount = undefined;
    this.reason = undefined;
    this.maxAdditionalDisks = undefined;
    this.maxTotalDisks = undefined;
    this.storageTier = undefined;
    this.encryptionMandatory = undefined;
    this.engineerAdd = undefined;
    this.engineerResize = undefined;
    this.notes = undefined;
  }
}
